import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      return;
    }

    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      await fetch('https://readdy.ai/api/form/d91o187efssur58kqnp0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-12 md:py-16 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20studio%20with%20a%20minimal%20cream%20sofa%20and%20a%20coffee%20table%20with%20a%20laptop%2C%20surrounded%20by%20beautifully%20arranged%20shopping%20bags%20and%20folded%20garments%20in%20neutral%20tones%2C%20warm%20golden%20hour%20light%20streaming%20through%20sheer%20curtains%2C%20aspirational%20lifestyle%20photography%2C%20soft%20shadows%2C%20airy%20composition&width=1600&height=600&seq=cta-pandabuy-v3-2026&orientation=landscape"
          alt="pandabuy spreadsheet lifestyle scene"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
          Start Exploring the Best pandabuyspreadsheet Today
        </h2>
        <p className="text-sm md:text-base text-white/75 mb-6 max-w-lg mx-auto leading-relaxed">
          Join thousands of savvy shoppers who discover trending products through our curated spreadsheets every day.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
          <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer">
            pandabuy sheet<i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-foreground-950 bg-accent-400 hover:bg-accent-500 rounded-md transition-colors whitespace-nowrap cursor-pointer">
            Buy It Now<i className="ri-shopping-cart-line ml-2"></i>
          </a>
        </div>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-5 md:p-6 max-w-md mx-auto">
          <p className="text-sm font-medium text-white mb-3">Get Weekly Spreadsheet Updates</p>
          <form id="newsletter-form" data-readdy-form="d91o187efssur58kqnp0" onSubmit={handleSubmit}>
            <div className="website-alt-wrapper">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <input type="email" name="email" placeholder="Your email address" value={email} onChange={(e) => setEmail(e.target.value)} required className="flex-1 px-4 py-2.5 text-sm bg-white/15 border border-white/25 rounded-md text-white placeholder:text-white/50 focus:outline-none focus:border-white/50 transition-colors" />
              <button type="submit" disabled={status === 'loading' || status === 'success'} className="px-5 py-2.5 text-sm font-semibold text-foreground-950 bg-accent-400 hover:bg-accent-500 rounded-md transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60">
                {status === 'loading' ? 'Subscribing...' : status === 'success' ? 'Subscribed!' : 'Subscribe'}
              </button>
            </div>
          </form>
          {status === 'success' && (
            <p className="text-xs text-accent-300 mt-2">You are now subscribed to weekly updates!</p>
          )}
          {status === 'error' && (
            <p className="text-xs text-red-300 mt-2">Something went wrong. Please try again.</p>
          )}
        </div>
      </div>
    </section>
  );
}